import React, { useState, useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton } from '@chakra-ui/react';
import { useToast } from '@chakra-ui/react';
import { useGoogleCalendarSettings } from 'hooks/useGoogleCalendarSettings';
import GoogleCalendarSettings from 'components/page-components/actions/GoogleCalendar/GoogleCalendarSettings';

const AgentGoogleCalendar = ({ onClose }) => {
    const { isLoggedIn, settingsData, refresh, getAuthUrl, initiated } = useGoogleCalendarSettings();
    const [calendarSettings, setCalendarSettings] = useState({
        selectedCalendar: { id: '', name: '' },
        timeInterval: 15,
        defaultEventDuration: 30,
        customVariables: [],
        schedule: {},
        startTimeIncrements: { ':15': true, ':30': true, ':00': true },
        listOfCalendars: [],
    });
    const [calendarSaveLoading, setCalendarSaveLoading] = useState(false);
    const toast = useToast();
    const [hasFetchedAuthUrl, setHasFetchedAuthUrl] = useState(false);

    useEffect(() => {
        if (settingsData) {
            setCalendarSettings({
                selectedCalendar: { id: settingsData?.chosen_calendars?.selected_calendar_id || '', name: settingsData?.chosen_calendars?.selected_calendar_name || '' },
                timeInterval: settingsData?.chosen_calendars?.time_interval ? parseInt(settingsData.chosen_calendars.time_interval) : 15,
                defaultEventDuration: settingsData?.chosen_calendars?.default_event_duration ? parseInt(settingsData.chosen_calendars.default_event_duration) : 30,
                customVariables: settingsData?.chosen_calendars?.custom_variables || [],
                schedule: settingsData?.chosen_calendars?.schedule || {},
                startTimeIncrements: settingsData?.chosen_calendars?.start_time_increments || { ':15': true, ':30': true, ':00': true },
                listOfCalendars: settingsData?.calendars || [],
            });
        }
    }, [settingsData]);
    const fetchAuthUrl = async () => {
        try {
            console.log('Fetching Google Calendar auth URL...');
            const url = await getAuthUrl();
            window.open(url, '_blank', 'noopener,noreferrer');
            onClose();
        } catch (err) {
            toast({
                title: "Failed to get authorization link",
                description: "Please try again later.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    useEffect(() => {
        if (initiated && !isLoggedIn && !hasFetchedAuthUrl) {
            fetchAuthUrl();
            onClose();
        }
    }, [initiated, isLoggedIn, hasFetchedAuthUrl]);

    if (initiated && !isLoggedIn) {
        return null;
    }

    if (!initiated || !isLoggedIn) {
        return null;
    }

    return (
        <Modal isOpen={true} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent maxW="1000px" minW="420px">
                <ModalCloseButton />
                <ModalBody p={6} overflowY="auto" maxH="calc(100vh - 150px)">
                    <GoogleCalendarSettings
                        isEnabled={true}
                        isLoggedIn={isLoggedIn}
                        onSettingsRefresh={refresh}
                        isSaving={calendarSaveLoading}
                        setCalendarSettings={setCalendarSettings}
                        calendarSettings={calendarSettings}
                        setCalendarSaveLoading={setCalendarSaveLoading}
                        toast={toast}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default AgentGoogleCalendar;